/** Scoped dark theme for the global demo event page only — does not change admin/workspace theme. */
export default function EventDemoScope({ children }) {
  return <div className="aivory-event-demo min-h-screen text-[var(--text-primary)]">{children}</div>;
}
